import { render, staticRenderFns } from "./TagRemoveIcon.vue?vue&type=template&id=94712406&scoped=true"
import script from "./TagRemoveIcon.vue?vue&type=script&lang=js"
export * from "./TagRemoveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94712406",
  null
  
)

export default component.exports